<ion-app dir="{{ textDir }}" class="scanner-hide">
  <ion-split-pane contentId="menu-content" when="false">
    <ion-menu contentId="menu-content" class="app-sidemenu">
      <ion-header>
        <ion-toolbar>
          <ion-row class="user-details-wrapper">
            <ion-col size="4">
              <app-aspect-ratio [ratio]="{ w: 1, h: 1 }">
                <div class="logoarea">
                  <img class="user-avatar" [src]="sharedSvc?.drawerHeaderLogo || './assets/images/eprintit-logo.png'" />
                </div>
              </app-aspect-ratio>
            </ion-col>
            <ion-col class="user-info-wrapper" size="8">
              <h3 class="user-name">{{"SETTINGS"| translate }}</h3>
            </ion-col>
          </ion-row>
          <!-- <ion-row class="user-stats-wrapper user-details-wrapper">
            <ion-col>
              <span class="user-stat-value">1553</span>
              <span class="user-stat-name">Following</span>
            </ion-col>
            <ion-col>
              <span class="user-stat-value">537</span>
              <span class="user-stat-name">Followers</span>
            </ion-col>
          </ion-row> -->
        </ion-toolbar>
      </ion-header>
      <ion-content data-cy="menuContent">
        <!-- <ion-list>
          <ion-list-header>
            <ion-label>USER ACCOUNTS</ion-label>
          </ion-list-header>
          <ion-menu-toggle
            autoHide="false"
            *ngFor="let p of appPages; let i = index"
          >
            <ion-item [routerLink]="p.url">
              <ion-icon
                slot="start"
                [name]="p.ionicIcon ? p.ionicIcon : ''"
                [src]="p.customIcon ? p.customIcon : ''"
              ></ion-icon>
              <ion-label>
                {{ p.title }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list> -->
        <ion-list>
          <ion-list-header>
            <ion-label> {{ 'USER_ACCOUNTS' | translate }}</ion-label>
          </ion-list-header>
          <!-- <ion-menu-toggle
            autoHide="true"
            
          > -->
          <ion-menu-toggle autoHide="false">
            <ion-item data-cy="addEditAccountMenuItem" (click)="navigateToAccounts()">
              <ion-icon slot="start" color="light" name="person"></ion-icon>
              <ion-label color="light">
                {{ 'ADD_EDIT_ACCOUNTS' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-item *ngIf="sharedSvc.showAccountOnlySection">
            <ion-icon slot="start" color="light" name="log-out"></ion-icon>
            <ion-label color="light">
              {{ 'ACCOUNT_ONLY' | translate }}
            </ion-label>
            <ion-toggle id="accountOnly" [disabled]="loginAccountService.autoAccountAvail$ | async" 
              checked="{{sharedSvc.accountOnly}}" (ionChange)="accountOnlyHandler()">
            </ion-toggle>
          </ion-item>
          <ion-menu-toggle autoHide="false" *ngIf="sharedSvc?.getCustomerDetails && (loginAccountService.authenticatedAccount$ | async).length">
            <ion-item data-cy="viewBalanceMenuItem" (click)="navigateToSelectAccount('view-balance')">
              <ion-icon slot="start" color="light" name="cash"></ion-icon>
              <ion-label color="light">
                {{ 'VIEW_BALANCE' | translate }}
              </ion-label>
            </ion-item>
            <ion-item data-cy="addBalanceMenuItem" (click)="navigateToSelectAccount('add-balance')">
              <ion-icon slot="start" color="light" name="wallet"></ion-icon>
              <ion-label color="light">
                {{ 'ADD_BALANCE' | translate }}
              </ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- </ion-menu-toggle> -->
        </ion-list>
        <ion-list *ngIf="cloudStorageToggle">
          <ion-list-header>
            <ion-label> {{ 'LINKED_STORAGE_ACCOUNTS' | translate }}</ion-label>
          </ion-list-header>
          <!-- <ion-menu-toggle
            autoHide="true"
            
          > -->
          <ng-container *ngFor="let p of accountPages; let i = index">
          <ion-item *ngIf="p.isVisible">
            <ion-icon slot="start" color="light" [name]="p.ionicIcon ? p.ionicIcon : ''"></ion-icon>
            <ion-label color="light">
              {{ p.title }}
            </ion-label>
            <ion-toggle [(ngModel)]="p.isEnabled" (ionChange)="switchToggle(p.title, p.isEnabled)"></ion-toggle>
          </ion-item>
          </ng-container>
          <!-- </ion-menu-toggle> -->
        </ion-list>
        <ion-list>
          <ion-list-header>
            <ion-label>{{ 'LANGUAGE' | translate }}</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item data-cy="changeLanguageMenuItem" (click)="navigateToLanguages()">
              <ion-icon color="light" slot="start" name="language-outline"></ion-icon>
              <ion-label color="light"> {{ 'CHANGE_LANGUAGE' | translate }} </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
        <ion-list>
          <ion-list-header>
            <ion-label>{{ 'HELP' | translate }}</ion-label>
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item href="mailto:support@eprintit.com?subject={{
                deviceInfo ? deviceInfo.model : ''
              }} application support&body={{'APPLICATION_VERSION'|translate}}: {{appVersion}}%0D%0A {{'DEVICE_MODEL'|translate}}: {{
                deviceInfo ? deviceInfo.model : ''
              }}%0D%0A {{'OS_VERSION'| translate}}: {{ deviceInfo ? deviceInfo.osVersion : '' }}">
              <ion-icon color="light" slot="start" name="help-buoy-outline"></ion-icon>
              <ion-label color="light"> {{ 'CONTACT_SUPPORT' | translate }} </ion-label>
            </ion-item>
            <ion-item data-cy="aboutMenuItem" (click)="navigateToAbout()">
              <ion-icon color="light" slot="start" name="information-circle-outline"></ion-icon>
              <ion-label color="light"> {{ 'ABOUT' | translate }} </ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="menu-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>